<div class="flex-grow-1" [class.overflow-auto]="!collapsed">
    <ng-content></ng-content>
</div>
@if (alertChildren && alertChildren.length > (collapseLimit || 0)) {
    <div class="d-flex justify-content-end mt-1">
        <button
            [wdxButton]="WdxButtonStyle.OutlinePrimary"
            [wdxButtonSize]="WdxButtonSize.Sm"
            (click)="toggleCollapse()"
        >
            {{
                collapsed
                    ? ('TIMELINE_SHOW_ALL' | translateTokenisedString) +
                      ' (' +
                      alertChildren.length +
                      ')'
                    : ('TIMELINE_SHOW_HIDE' | translateTokenisedString)
            }}
        </button>
    </div>
}
